import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Heading,
  Button,
  Box,
  VStack,
  HStack,
  Divider,
  Text,
} from 'native-base';
import { FoodRestrictions } from '../Common/FoodRestrictions';
import { Drawer } from '../Drawer';
import { useAuth } from '../../hooks';
import { ModalType, useModalsContext } from '../../hooks/useModalsContext';

export const DietHealthDrawer = () => {
  const { user, updateUserSelf } = useAuth();
  const navigate = useNavigate();
  const { dispatch } = useModalsContext();
  const { first_name, last_name } = user;

  const onCloseModal = useCallback(() => {
    dispatch({ type: 'closeModal' });
  }, [dispatch]);

  const prettierDiagnosisString = () => {
    const diagnosis = user.diagnosis;

    if (diagnosis) {
      if (diagnosis === 'CD Symptoms') {
        return "Crohn's Disease";
      } else if (diagnosis === 'UC Symptoms') {
        return 'Ulcerative Colitis';
      } else if (diagnosis === 'IBS & Other') {
        return 'Irritable Bowel Syndrome';
      }
    } else {
      return 'No Diagnosis';
    }
  };

  return (
    <Drawer
      onClose={() => {
        navigate(`/dashboard`);
      }}
      header={`${first_name} ${last_name[0]}.`}
    >
      <Heading size={'xl'} fontFamily="heading">
        Health & Diet
      </Heading>
      <VStack w={'100%'} mt={6}>
        <Heading size={'md'} fontFamily="heading" mb={4}>
          Health Information
        </Heading>
        <HStack w={'100%'} justifyContent={'space-between'}>
          <Box>
            <Text mb={2} textAlign="left" fontWeight={600}>
              Condition
            </Text>
            <Text fontWeight={'normal'}>{prettierDiagnosisString()}</Text>
          </Box>
          <Button
            variant={'link'}
            onPress={() =>
              dispatch({
                type: 'openModal',
                modalId: ModalType.DashboardInfoModal,
                modalData: {
                  onClose: onCloseModal,
                },
              })
            }
          >
            How do I change this?
          </Button>
        </HStack>
        <Divider my={4} />
        <Heading size={'md'} fontFamily="heading" mb={4}>
          Food Restrictions
        </Heading>
        <FoodRestrictions
          allergies={user?.allergen_ids ?? []}
          restrictions={user?.dietary_restriction_ids ?? []}
          avoided={user?.selected_food_ids ?? []}
          other={user?.other_diet_ids ?? []}
          onChange={async ({ allergies, restrictions, avoided, other }) => {
            await updateUserSelf({
              allergen_ids: allergies,
              dietary_restriction_ids: restrictions,
              selected_food_ids: avoided,
              other_diet_ids: other,
            });
          }}
        />
      </VStack>
    </Drawer>
  );
};
